import * as R from 'ramda';

/**
 * App config.
 */
const appConfig = {
  apiUrl: R.defaultTo('trueprodigyapi.com', process.env.API_URL),
  environment: R.defaultTo('dev', process.env.API_ENVIRONMENT),
};

export default appConfig;
